import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from '@packages/api';
import { reactivateSubscription } from '@packages/api/endpoints/subscription.js';
import { useAuth } from '../auth/useAuth';

/**
 * Reactivates a CANCELLING subscription free of charge, within its paid
 * period. Shared by the subscription settings section and the app-wide
 * banner so both Renew affordances invalidate the same single query key
 * (the subscription itself carries the only state either surface reads).
 * The global toast is suppressed - both callers surface the error inline
 * next to their own Renew button.
 */
export function useReactivateSubscriptionMutation() {
  const { accountId } = useAuth();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => reactivateSubscription(accountId!),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.subscription(accountId!) });
    },
    onError: () => {
      // Suppress global toast - error is shown inline below the Renew button.
    },
  });
}
